import { Action } from './core/action';

export class PreInfoSaleAction implements Action {
  constructor(public type: string, public paymentType?: string) {}
}



// WEBPACK FOOTER //
// src/app/common/actions/pre-info-action.ts